






























































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";
import moment from 'moment';

declare var amp: any;

@Component
export default class PreModuleWork extends Vue {
  private tableItems = localStorage[config.selectedWork]!=="undefined" ? JSON.parse(localStorage[config.selectedWork]) : null;
  private tableItemsSorted = this.sortArray(this.tableItems);
  private selectedWorkItem: any = [];
  private selected = [];
  private display: any = [];
  private correct: any = [];
  private disable: any = [];
  private answerAns: any = [];
  private attempted = 0;
  private currentDay = '2020-04-13';
  private player: any;
  private errorMessage = '';
  private sourceLoaded = false;
  private view = 0;
  private currentWorkItem = 0;
  private source = "//elvideoservices-aase.streaming.media.azure.net/7bde64ac-5624-4b25-9c6b-97a24edb6208/chem1ch3lect1-new.ism/manifest";
  private isFirst = localStorage[config.dayModal];
  private auth = new AuthService();
  private lastTime = 0;
  private errorDisable = false;
  private startError = false;
    
  private showDetails(item, index) {
    this.selectedWorkItem = item;
    this.currentWorkItem = index;
    this.view = 1;
    if (this.selectedWorkItem.VideoLink){
      this.source = this.selectedWorkItem.VideoLink;
      setTimeout(()=>{this.loadVideo()}, 1000);
    }

    if (this.selectedWorkItem.Mcqs) {
      for (let i = 0; i < this.selectedWorkItem.Mcqs.length; i++){
        for (let j = 0; j < this.selectedWorkItem.Mcqs[i].answers.length; j++){
          if (this.selectedWorkItem.Mcqs[i].answers[j].isCorrect)
            this.correct[i] = this.selectedWorkItem.Mcqs[i].answers[j].answerText;
        }
      }
    }
  }

  private nextWork(){
    if (this.currentWorkItem < this.tableItemsSorted.length - 1){
      this.currentWorkItem++;
      this.showDetails(this.tableItemsSorted[this.currentWorkItem], this.currentWorkItem);
    }
  }

  private renderHTML(x) {
    return config.renderHTML(x)
  }

  private previousWork(){
    if (this.currentWorkItem !== 0){
      this.currentWorkItem--;
      this.showDetails(this.tableItemsSorted[this.currentWorkItem], this.currentWorkItem);
    }
  }

  private openHelp() {
    this.$bvModal.show('how-to');
  }

  private joinTeam() {
    window.open('https://teams.microsoft.com/', '_blank');
  }

  private goBack() {
    this.sourceLoaded = false;
    this.errorDisable = true;
    window.location.reload();
  }

  private rowClass(item, type) {
    if (!item || type !== "row") return;

    return "cursor-pointer";
  }

  private fields = [
    { key: "Type" },
    { key: "CourseId", label: "Subject"},
    { key: "Title" },
    { key: "Description" }
  ];

checkAnswer(answer, i){
    this.display[i] = true;
    if (this.correct[i] === answer.answerText){
      Vue.set(this.answerAns, i, 'alert-success');
    } else {
      Vue.set(this.answerAns, i, 'alert-danger');
    }
    if (!this.disable[i])
      this.attempted++;

    this.disable[i] = true;
}

private resetMcqs() {
  this.attempted = 0;
  this.display = [];
  this.disable = [];
  this.answerAns = [];
  this.selected = [];
}

sortArray(array) {
  return array.sort(function(a, b) {
    let nameA = a.CourseId.toLowerCase(),
      nameB = b.CourseId.toLowerCase();
    if (nameA < nameB)
      //sort string ascending
      return -1;
    if (nameA > nameB) return 1;
    return 0; //default return value (no sorting)
  });
}

private loadVideo() {
    let client = document.getElementById("main-content");
    if (client !== null) {
      this.player = amp("azuremediaplayer", {
        nativeControlsForTouch: false,
        logo: { enabled: false },
        autoplay: true,
        controls: true,
        width: "auto",
        height: 600,
        techOrder: [
          "azureHtml5JS",
          "flashSS",
          "html5FairPlayHLS",
          "silverlightSS",
          "html5"
        ]
      });
    } else {
   
    }
    this.player.src([
      { type: "application/vnd.ms-sstr+xml", src: this.source }
    ]);

    this.player.addEventListener('error', this.errorPlayback);

    this.sourceLoaded = true;
  }

  errorPlayback() {
    this.errorMessage = 'There was an issue in your playback, kindly check your internet connection. We will reload the video so you can seamlessly view it again.';
   
    
    this.lastTime = this.player.currentTime();
    this.startError = true;
    
    this.player.src([
      { type: "application/vnd.ms-sstr+xml", src: this.source }
    ]);
  }

  mounted() {
    if (!this.auth.session){
      this.$router.push('/');
    }

    if (!this.selectedWorkItem || !this.$route.params.day){
        this.$router.push('/pre-module');
    } else {
        this.currentDay = moment(this.$route.params.day).format('LL');
    }

    setInterval(()=>{
      if (this.player.error() == null && this.startError){
        this.startError = false;
        this.player.currentTime(this.lastTime);
        this.errorMessage = '';
      }
    }, 1000);
    

    window.onpopstate = function() {
      window.location.reload();
    };
  }
}
